<div id="div_{{chartDivName}}" [ngStyle]="{'height': chartHeigth }" [ngClass]="hasPhases ? htmlClasses : 'd-none'"  ></div>
